module.exports = {
      id: "logout-mobile-usage",
      viewBox: "0 0 20.886 28.808",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#logout-mobile",
      toString: function () {
        return this.url;
      }
    }